import React from 'react';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from './mixins/shared/string_constants_mixin';
import FormButton from '../../../components/forms/FormButton';

const createReactClass = require('create-react-class');

const ConnectAppleButton = createReactClass({
  componentDidMount() {
    ServerCommunicationUtil.initApple(this.props.authState);
  },
  handleUnlinkClick() {
    _gaq.push(['_trackEvent', 'Account Settings', 'Apple', 'Unlink']);
    ServerCommunicationUtil.postApiEndpoint(
      this.props.unlinkPath,
      {}
    );
  },
  render() {
    let button;
    if (this.props.appleSigninId) {
      button = (
        <li className="mark no-underline">
          <form onSubmit={this.handleUnlinkClick}>
            {StringConstantsMixin.strings.SIGNUP.CONNECTED} (
            <FormButton className="underline unlink" value={StringConstantsMixin.strings.SIGNUP.UNLINK}/>
            )
          </form>
        </li>
      );
    } else {
      button = (
        <a className="account-settings flat-apple-btn apple">
          <div>
            <span>{StringConstantsMixin.strings.SIGNUP.CONNECT_WITH_APPLE}</span>
          </div>
        </a>
      );
    }
    return <ul className="sidebar-facebook">{button}</ul>;
  }
});

export { ConnectAppleButton };
